<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Staff Form Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`Update ${staff.formatName(true, true)}`"
      class="mb-3"
    >
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'edit staff'">
      <template #gated-content>
        <staff-form :staff="staff" @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import StaffForm from "@/components/lab/staff/StaffForm";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { staffNotifications } from "@/shared/notifications";
import { getModel } from "@/shared/fetch-utils";

const StaffRepository = LabRepositoryFactory.get("staff");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "StaffEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    StaffForm,
  },
  mixins: [ToastNotifications],
  data() {
    return {
      loading: true,
      staff_id: this.$route.params.staff_id || null,
      staff: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/staff",
            title: "Staff list",
          },
          {
            icon: "fa-eye",
            linkto: `/staff/${this.staff_id}`,
            title: "View staff",
            variant: "info",
          },
        ],
      };
    },
  },
  methods: {
    async submit(form_data) {
      try {
        await StaffRepository.update(this.staff_id, form_data);

        this.editSuccess();
        this.$router.push(`/staff/${this.staff_id}`);
      } catch ({ response }) {
        const { status, data } = response;

        this.$bvToast.toast(`Code: ${status}. ${data.error || data.message}`, {
          title: "Server Error.",
          variant: "danger",
        });
      }
    },
  },
  async created() {
    this.loading = true;

    this.staff = await getModel({
      model_type: "staff",
      id: this.staff_id,
      message: this.$bvToast,
    });

    this.loading = false;
  },
  notifications: staffNotifications,
};
</script>
